// TEMP all values in this list are hardcoded on server side!
export default {
  setup_fee: 24900,
  live_answering: {
    from: 9900,
    user: 5000
  },
  api_fee: 2500,
  systems_fees: {
    hubspot: 2500,
    officernd: 2500,
    deskworks: 2500,
    quickbooks: 2500,
    nexudus: 2500
  }
}